import { NavItem } from '@config/nav'
import {
    EuiFlexGroup,
    EuiFlexItem,
    EuiHeaderLink,
    EuiHeaderLinks,
    EuiPopover,
    EuiText,
} from '@elastic/eui'
import { buildHref, isNavActive } from '@utils/nav'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const HeaderNavPopover = ({
    item,
    isOpen,
    onOpen,
    onClose,
}: {
    item: NavItem
    isOpen: boolean
    onOpen: () => void
    onClose: () => void
}) => {
    const { t } = useTranslation(['navigation'])
    const hasSubItems = item.items && item.items.length > 0

    const link = (
        <EuiHeaderLink
            size="s"
            iconType={item.icon}
            onMouseEnter={hasSubItems ? onOpen : undefined}
            isActive={isNavActive(item)}
            href={!hasSubItems ? buildHref(item.href) : undefined}
        >
            <EuiText size="s">{t(item.name)}</EuiText>
        </EuiHeaderLink>
    )

    return (
        <EuiPopover
            key={item.id}
            isOpen={isOpen}
            closePopover={onClose}
            panelPaddingSize="s"
            button={link}
        >
            <EuiFlexGroup
                direction="column"
                onMouseLeave={hasSubItems ? onClose : undefined}
                justifyContent="center"
                alignItems="center"
            >
                {hasSubItems &&
                    item.items &&
                    item.items.map((sub) => (
                        <EuiFlexItem
                            grow
                            style={{ width: '100%' }}
                            key={sub.id}
                        >
                            <EuiHeaderLink
                                style={{ width: '100%' }}
                                href={buildHref(sub.href)}
                                isActive={isNavActive(sub)}
                                iconType={sub.icon}
                            >
                                <EuiText size="s">{t(sub.name)}</EuiText>
                            </EuiHeaderLink>
                        </EuiFlexItem>
                    ))}
            </EuiFlexGroup>
        </EuiPopover>
    )
}

const HeaderDesktopNav = ({ items }: { items: NavItem[] }) => {
    const [openNavItem, setOpenNavItem] = useState<string | undefined>(
        undefined
    )

    return (
        <EuiHeaderLinks gutterSize="l">
            {items.map((item) => (
                <HeaderNavPopover
                    item={item}
                    onClose={() => setOpenNavItem(undefined)}
                    onOpen={() => setOpenNavItem(item.id)}
                    isOpen={openNavItem === item.id}
                    key={item.id}
                />
            ))}
        </EuiHeaderLinks>
    )
}

export default HeaderDesktopNav
